import { CatalogProduct } from '@interfaces/models/catalogProduct';
import { useBucket } from '@context/bucket.context';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useLocalStorage from '@hooks/use-local-storage';

const useHighlightDutiesTooltip = (products: CatalogProduct[]) => {
  const { isFeatureEnabled } = useBucket();
  const isShowTaxIconEnabled = isFeatureEnabled((f) => f.enableWebDutiesPlpXp, true);

  const [showTooltip, setShowTooltip] = useState(false);

  const [hasTooltipBeenShown, setHasTooltipBeenShown] = useLocalStorage('localsave/hasDutiesTooltipBeenShown', false);

  const [hasBannerBeenShown, setHasBannerBeenShown] = useLocalStorage('localsave/hasDutiesBannerBeenShown', false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (isShowTaxIconEnabled && !hasBannerBeenShown && products?.some((product) => product.hasDutiesApplied)) {
      setShowBanner(true);
      setHasBannerBeenShown(true);
    }
  }, [products, hasBannerBeenShown, isShowTaxIconEnabled]);

  const onRowVisibleCallback = useCallback(
    (row: CatalogProduct[]) => {
      if (!isShowTaxIconEnabled) {
        return;
      }
      if (!showTooltip && !hasTooltipBeenShown && row.some((product) => product.hasDutiesApplied)) {
        setShowTooltip(true);
        setHasTooltipBeenShown(true);
      }
    },
    [showTooltip, hasTooltipBeenShown, setHasTooltipBeenShown, isShowTaxIconEnabled],
  );

  const shouldMountDutiesTooltip = useMemo(() => {
    if (!isShowTaxIconEnabled) {
      return false;
    }
    return products.some((x) => x.hasDutiesApplied);
  }, [isShowTaxIconEnabled, products]);

  // hide the auto-show tooltip when the user scrolls
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    const hideTooltipListener = () => {
      setShowTooltip(false);
    };

    if (showTooltip) {
      // delay adding of scroll listener to avoid hiding tooltip straight away
      setTimeout(() => {
        window.addEventListener('scroll', hideTooltipListener);
      }, 1000);
    }
    return () => {
      window.clearTimeout(timeout);
      window.removeEventListener('scroll', hideTooltipListener);
    };
  }, [showTooltip]);

  return { showTooltip, setShowTooltip, onRowVisibleCallback, shouldMountDutiesTooltip, showBanner, setShowBanner };
};

export default useHighlightDutiesTooltip;
